import { IWebsiteBuilderRoot } from "pages/secure/facility/websiteBuilder/editor/nodes/websiteBuilderRoot";
import { WebsiteBuilderActionType } from "../../websiteBuilderAction";
import { elementTreeTraversal } from "../../actionHelpers/elementTreeTraversal";

export interface IBringToFrontElementPayload {
  id: string;
  prevZIndex: number;
  nextZIndex: number;
}

export interface IBringToFrontElementAction {
  type: typeof WebsiteBuilderActionType.BRING_TO_FRONT_ELEMENT;
  payload: IBringToFrontElementPayload;
}

export function getBringToFrontElementInverseAction(action: IBringToFrontElementAction): IBringToFrontElementAction {
  const { id, prevZIndex, nextZIndex } = action.payload;

  return {
    type: WebsiteBuilderActionType.BRING_TO_FRONT_ELEMENT,
    payload: {
      id,
      prevZIndex: nextZIndex,
      nextZIndex: prevZIndex,
    },
  };
}

export function applyBringToFrontElementTreeChange(
  tree: IWebsiteBuilderRoot,
  action: IBringToFrontElementAction,
): IWebsiteBuilderRoot {
  const { id, nextZIndex } = action.payload;

  const updatedTree = elementTreeTraversal(tree, id, {
    zIndex: nextZIndex,
  });

  return updatedTree;
}
